import React from 'react'
import LayoutAdmin from '../../components/layout/LayoutAdmin'

const SAUsers = () => {
  return (
    <LayoutAdmin>
      <h2 className="text-xl font-semibold mb-4">Super Admin - Users</h2>
      <div className="bg-white border rounded p-4">This is a dummy Super Admin Users page.</div>
    </LayoutAdmin>
  )
}

export default SAUsers


